<div class="full-width is-flex has-flex-content-space-between">
  <label class="text-label" for="{{inputId}}">{{label}}</label>
  <div class="onoffswitch">
    <input type="checkbox" name="{{inputId}}" class="onoffswitch-checkbox" id="{{inputId}}" [(ngModel)]="checked" [disabled]="checked && !allowUncheck"
    >
    <div class="onoffswitch-box" (click)="toggle()" tabindex="0" role="menuitemcheckbox" (keydown.enter)="toggle()" [attr.aria-checked]="checked"></div>
  </div>
</div>
